import { Breed } from './../models/breed.model';
import { Species } from 'src/app/core/models/species.model';
import { selectAllSpecies } from './../../store/species/species.selectors';
import { filter, shareReplay, take } from 'rxjs/operators';
import { CabinetService } from 'src/app/core/services/cabinet.service';
import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { firestore } from 'firebase/app';
import { Store } from '@ngrx/store';
import { SpeciesState } from 'src/app/store/species/species.reducer';
import { startCase, toLower } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class SpeciesService {

  species$ = this.store.select(selectAllSpecies).pipe(shareReplay(1));

  constructor(
    private afs: AngularFirestore,
    private cabinetService: CabinetService,
    private store: Store<SpeciesState>,
  ) { }

  addSpecies(name: string) {
    const value = name.toLowerCase();
    return this.cabinetService.cabinetId$.pipe(
      filter(id => !!id),
      take(1)
    ).subscribe(id => this.afs.collection('cabinets').doc(id).collection('species').doc(value).set({
      name: this.toTitleCase(name),
      value,
      frequency: 1
    }));
  }

  addBreed(species: Species, name: string) {
    const value = name.toLowerCase();
    return this.cabinetService.cabinetId$.pipe(
      filter(id => !!id),
      take(1)
    ).subscribe(id => this.afs.collection('cabinets').doc(id).collection('species').doc(species.value).update({
      breeds: {
        ...species.breeds,
        [value]: {
          name: this.toTitleCase(name),
          value,
          frequency: 1
        }
      }
    }));
  }

  removeSpecies(species: Species) {
    return this.cabinetService.cabinetId$.pipe(
      filter(id => !!id),
      take(1)
    ).subscribe(id => this.afs.collection('cabinets').doc(id).collection('species').doc(species.value).delete());
  }

  removeBreed(species: Species, breed: Breed) {
    const filteredBreeds = { ...species.breeds };
    delete filteredBreeds[breed.value];
    return this.cabinetService.cabinetId$.pipe(
      filter(id => !!id),
      take(1)
    ).subscribe(id => this.afs.collection('cabinets').doc(id).collection('species').doc(species.value).update({
      breeds: { ...filteredBreeds }
    }));
  }

  increaseFrequency(species: Species) {
    return this.cabinetService.cabinetId$.pipe(
      filter(id => !!id),
      take(1)
    ).subscribe(id => this.afs.collection('cabinets').doc(id).collection('species').doc(species.value).update({
      frequency: firestore.FieldValue.increment(1)
    }).catch(error => {
      this.afs.collection('cabinets').doc(id).collection('species').doc(species.value).set({
        ...species,
        frequency: 1
      });
    }));
  }

  increaseBreedFrequency(species: Species, breed: Breed) {
    return this.cabinetService.cabinetId$.pipe(
      filter(id => !!id),
      take(1)
    ).subscribe(id => this.afs.collection('cabinets').doc(id).collection('species').doc(species.value).update({
        breeds: {
          ...species.breeds,
          [breed.value]: {
            ...breed,
            frequency: breed.frequency + 1
          }
        }
      })
    );
  }

  toTitleCase(string: string): string {
    return startCase(toLower(string));
  }
}
